import type {
  GetProgressResponse,
  GetVideoByIdPayload,
  GetVideoByIdResponse,
  PostEventPayload,
} from "~/repository/videos.types";

export async function getVideoById(
  payload: GetVideoByIdPayload,
): Promise<GetVideoByIdResponse> {
  const { videoId } = payload;
  const { $api } = useNuxtApp();
  return await $api("v4")(`/videos/${videoId}`);
}

export async function getProgress(): Promise<GetProgressResponse> {
  const { $api } = useNuxtApp();
  try {
    return await $api("event-service")(`/subscribers/me/progress`);
  } catch (e) {
    return {
      data: {
        total: 0,
        videos: [],
      },
    };
  }
}

export async function postEvent(
  payload: PostEventPayload,
): Promise<GetProgressResponse> {
  const { $api } = useNuxtApp();
  return await $api("event-service")(`/subscribers/me/events`, {
    method: "POST",
    body: payload,
    headers: { "Content-Type": "application/vnd.api+json" },
  });
}
